/** A nice enumeration of results that can be returned from a sort comparator. */
export enum ComparatorResult {
  BEFORE = -1,
  AFTER = 1,
  EQUAL = 0,
}
